import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselViewComponent } from './vessel-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { VesselViewRoutingModule } from './vessel-view-routing.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ChartModule } from 'angular-highcharts';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { GemininotesPopupModule } from '../gemininotes-popup/gemininotes-popup.module';

@NgModule({
  declarations: [VesselViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    CustomDatePickerModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    CustomTimpickerModule,

    CustomInputModule,
    MatProgressBarModule,
    ChartModule,
    PcMultiSelectFilterModule,
    GemininotesPopupModule,
    VesselViewRoutingModule,
  ],
})
export class VesselViewModule {}
